import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

interface ProgressModalProps {
  open: boolean;
  children: React.ReactNode;
  size?: 'xs' | 'sm' | 'md' | 'lg';
}

const ProgressModal: React.FC<ProgressModalProps> = ({ open, children, size = 'xs' }) => {
  return (
    <Dialog open={open} maxWidth={size} fullWidth>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
};

export default ProgressModal;
